import React, { Component, PropTypes } from 'react'

import { getProperty } from '../utils'
import { NoItemsTableRow } from '../misc'
import { Button } from '../ui'
import AdditionalCitySelectionForm from './additional_city_selection_form'

export default class AdditionalCities extends Component {
    static propTypes = {
        country: PropTypes.string.isRequired,
        countryCode: PropTypes.string.isRequired,
        crewUUID: PropTypes.string.isRequired,
        data: PropTypes.object,
        errors: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
        modalActions: PropTypes.object.isRequired,
        personalActions: PropTypes.object.isRequired,
    }

    static defaultProps = {
        errors: {},
    }

    _showAdditionalCitySelectionForm(additionalCity) {
        const data = additionalCity || { region: null }

        this.props.modalActions.showModal({
            component: (
                <AdditionalCitySelectionForm
                    country={ this.props.country }
                    crewUUID={ this.props.crewUUID }
                    data={ data }
                    useRegions={ this.props.countryCode === 'US' }
                />
            ),
        })
    }

    render() {
        const key = 'additional_cities'
        let data = []
        let items = []

        if (this.props.data && this.props.data[key]) {
            data = this.props.data[key]
        }

        if (data.length) {
            for (const item of data) {
                items.push((
                    <tr
                        className="table-row"
                        key={ item.uuid }
                    >
                        <td className="table-cell">
                            { item.city_obj.label }
                            { item.city_obj.state_name &&
                                `, ${ item.city_obj.state_name }`
                            }
                        </td>
                        <td className="table-cell text-right">
                            <Button
                                onClick={ (e) => {
                                    e.preventDefault()
                                    e.stopPropagation()

                                    // eslint-disable-next-line no-alert
                                    if (confirm('Are you sure you wish to delete this city?')) {
                                        this.props.personalActions.deleteAdditionalCity(this.props.crewUUID, item.uuid)
                                    }
                                } }
                                status="delete"
                            >
                                Delete
                            </Button>
                        </td>
                    </tr>
                ))
            }
        } else {
            items = <NoItemsTableRow colSpan="2" />
        }

        let errors = null

        if (getProperty(this.props.errors, key)) {
            errors = (
                <div className="alert alert--error">
                    { this.props.errors[key].map(
                        (item, index) => <p key={ index }>{ item }</p>
                    ) }
                </div>
            )
        }

        return (
            <div>
                { errors }

                <table className="table">
                    <tbody>
                        { items }
                    </tbody>
                </table>

                <Button onClick={ () => this._showAdditionalCitySelectionForm() } status="create">
                    Add new city
                </Button>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/personal/additional_cities.js